/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DeviceMobile: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M17.5 2C18.6046 2 19.5 2.89543 19.5 4V20C19.5 21.1046 18.6046 22 17.5 22H6.5C5.39543 22 4.5 21.1046 4.5 20V4C4.5 2.89543 5.39543 2 6.5 2H17.5ZM6.5 20H17.5V4H6.5V20ZM15 17C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17H15ZM13 5.5C13.5523 5.5 14 5.94772 14 6.5C14 7.05228 13.5523 7.5 13 7.5H11C10.4477 7.5 10 7.05228 10 6.5C10 5.94772 10.4477 5.5 11 5.5H13Z'
      fill='currentColor'
    />
  </React.Fragment>
)
